import { parseFilter } from "colbi_web_ui/lib/utils";

export const packagesAssociationQueries = (args = {}) => {
    const { entity, id, filter, locale, sort } = args;

    if (!entity) {
        return [];
    }

    return [
        {
            resource: entity,
            args: {
                packageId: +id,
                locale,
                pageSize: 20000,
                page: 0,
                filter: filter
                    ? { type: "[FilterInput!]", value: parseFilter(filter) }
                    : undefined,
                sort: sort ? { type: "[SortInput!]", value: parseFilter(sort) } : undefined,
            },
            body: `__typename, items{...${entity}}, hasMore, total, filters{ prop, name, type, list, disableOperators, mandatory }`,
            isDatagridReq: true,
            downloadable: true,
        },
    ];
};
